import { css } from '@emotion/css'

export const TableStyles = css`
  border: 1px solid #e5e5e5;
  border-radius: 8px;
`
